<section class="py-4">
  <div class="card mx-md-4 mx-2 mb-4">
    <div class="card-body row align-items-end">
      <div class="col-lg-6 col-12 p-2">
        <label for="nome">Nome</label>
        <input [readonly]="desativarInputsEBotoes===true" [formControl]="form.controls.nome" type="text" id="nome" class="form-control">
        <app-msg-erro [control]="form.controls.nome"></app-msg-erro>
      </div>
      <div class="col-lg-6 col-12 p-2">
        <label for="desc">Descrição</label>
        <input [readonly]="desativarInputsEBotoes===true" [formControl]="form.controls.descricao" type="text" id="desc" class="form-control">
        <app-msg-erro [control]="form.controls.descricao"></app-msg-erro>
      </div>
      <div class="col-6 col-lg-3 p-2">
        <label for="min">Consumo mínimo</label>
        <input [readonly]="desativarInputsEBotoes===true" [formControl]="form.controls.min" [textMask]="masks.moeda" placeholder="consumo em R$" type="text"
          min="0" id="min" class="form-control">
        <app-msg-erro [control]="form.controls.min"></app-msg-erro>
      </div>
      <div *ngIf="!desativarInputsEBotoes" class="col-6 col-lg-3 p-2">
        <label for="intervalo">Intervalo de cobrança</label>
        <select [formControl]="form.controls.intervalo" name="intervalo" id="intervalo" class="form-control">
          <option value="">Selecione</option>
          <option value="15">Quinzenal</option>
          <option value="30">Mensal</option>
        </select>
        <app-msg-erro [control]="form.controls.intervalo"></app-msg-erro>
      </div>
    </div>
  </div>
  <div class="container" style="margin-bottom: 10px;">
    <div class="row justify-content-md-center">
      <button *ngIf="desativarInputsEBotoes===false" class="btn btn-primary btn-sm btn-icon" (click)="aguardar(1000)" >
        <i class="mdi mdi-eye"></i>
        <span>Clique para carregar os valores</span>
      </button>
    </div>
  </div>
  <div *ngIf="listaConsulta.length>0" class="card mx-md-4 mx-2 mb-4">
    <div class="card-header bg-white">
      <h2>Consultas Veiculares</h2>
    </div>
    <div class="card-body p-0">
      <div class="row">
        <ng-container *ngFor="let c of listaConsulta; let i = index">
          <div class="col-12 col-md-6">
            <div class="border border-light d-block h-100">
              <div class="p-lg-4 p-2 row">
                <div class="fw-500 py-2">
                  {{c.consulta.nome}}
                </div>
                <app-input-range-quantidade-preco [disabled]="desativarInputsEBotoes" *ngIf="c.range.length>0" [formList]="c.range"></app-input-range-quantidade-preco>
                <div class="p-1 mt-1 rounded bg-light w-100 d-flex align-items-center justify-content-between">
                  <app-checkbox [disabled]="desativarInputsEBotoes" [(checked)]="c.cortesia" label='Cortesia'></app-checkbox>
                  <i *ngIf="c.cortesia" class="text-danger f-12">Ao marcar esta opção a consulta não será cobrada</i>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div *ngIf="listaConsultaCredito.length>0" class="card mx-md-4 mx-2 mb-4">
    <div class="card-header bg-white">
      <h2>Consultas Crédito</h2>
    </div>
    <div class="card-body p-0">
      <div class="row">
        <ng-container *ngFor="let c of listaConsultaCredito; let i = index">
          <div class="col-12 col-md-6">
            <div class="border border-light d-block h-100">
              <div class="p-lg-4 p-2 row">
                <div class="fw-500 py-2">
                  {{c.consulta.nome}}
                </div>
                <app-input-range-quantidade-preco [disabled]="desativarInputsEBotoes" *ngIf="c.range.length>0" [formList]="c.range"></app-input-range-quantidade-preco>
                <div class="p-1 mt-1 rounded bg-light w-100 d-flex align-items-center justify-content-between">
                  <app-checkbox [disabled]="desativarInputsEBotoes" [(checked)]="c.cortesia" label='Cortesia'></app-checkbox>
                  <i *ngIf="c.cortesia" class="text-danger f-12">Ao marcar esta opção a consulta não será cobrada</i>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div *ngIf="listaInsumoConsultas.length>0" class="card mx-md-4 mx-2 mb-4">
    <div class="card-header bg-white">
      <h2>Insumos</h2>
    </div>
    <div class="card-body p-0">
      <div class="row">
        <ng-container *ngFor="let insumo of listaInsumoConsultas; let i = index">
          <div class="col-12 col-md-6">
            <div class="border border-light d-block h-100">
              <div class="p-lg-4 p-2 row">
                <div class="fw-500 py-2">
                  {{insumo.insumo.nome}}
                </div>
                <app-input-range-quantidade-preco [disabled]="desativarInputsEBotoes" *ngIf="insumo.range.length>0" [formList]="insumo.range"></app-input-range-quantidade-preco>
                <div class="p-1 mt-1 rounded bg-light w-100 d-flex align-items-center justify-content-between">
                  <app-checkbox [disabled]="desativarInputsEBotoes" [(checked)]="insumo.cortesia" label='Cortesia'></app-checkbox>
                  <i *ngIf="insumo.cortesia" class="text-danger f-12">Ao marcar esta opção a consulta não será cobrada</i>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div *ngIf="listaConsultaCombinada.length>0" class="card mx-md-4 mt-4 mx-2">
    <div class="card-header bg-white">
      <h2>Consultas Combinadas</h2>
    </div>
    <div *ngIf="listaConsultaCombinada.length==0" class="card-body text-secondary text-center fw-500">
      Nenhum registro encontrado
    </div>
    <div *ngIf="listaConsultaCombinada.length>0" class="card-body p-0">
      <div class="row">
        <ng-container *ngFor="let c of listaConsultaCombinada; let i = index">
          <div class="col-12 col-md-6">
            <div class="border border-light d-block h-100">
              <div class="p-2 p-lg-4 row">
                <div class="fw-500 py-2">
                  {{c.consulta.nome}}
                </div>
                <app-input-range-quantidade-preco [disabled]="desativarInputsEBotoes" *ngIf="c.range.length>0" [formList]="c.range"></app-input-range-quantidade-preco>
                <div class="p-1 mt-1 rounded bg-light w-100 d-flex align-items-center justify-content-between">
                  <app-checkbox [disabled]="desativarInputsEBotoes" [(checked)]="c.cortesia" label='Cortesia'></app-checkbox>
                  <i *ngIf="c.cortesia" class="text-danger f-12">Ao marcar esta opção a consulta não será cobrada</i>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="card mx-md-4 mt-4 mx-2">
    <div class="card-header bg-white d-flex justify-content-between align-items-center">
      <h2>Combos</h2>
      <button *ngIf="desativarInputsEBotoes===false" class="btn btn-success btn-sm btn-icon" (click)="open(contentModalCombo)">
        <i class="mdi mdi-plus"></i>
        <span>Adicionar</span>
      </button>
    </div>
    <div *ngIf="listaCombos.length==0" class="card-body text-secondary text-center fw-500">
      Nenhum combo Cadastrado
    </div>
    <div *ngIf="listaCombos.length>0" class="card-body p-0">
      <div class="row">
        <ng-container *ngFor="let c of listaCombos; let i = index">
          <div class="col-12 col-md-6">
            <div class="border border-light d-block h-100">
              <div class="py-2 p-lg-4 row">
                <div class="py-2 d-flex align-items-center">
                  <button *ngIf="desativarInputsEBotoes===false" (click)="removerCombo(i)" class="btn btn-icon btn-xs btn-danger">
                    <i class="mdi mdi-delete"></i>
                  </button>
                  <span class="pl-2 fw-500">{{c.nome}}</span>
                </div>
                <app-input-range-quantidade-preco [disabled]="desativarInputsEBotoes" *ngIf="c.range.length>0" [formList]="c.range">
                </app-input-range-quantidade-preco>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="mb-5 py-5 mx-2 mx-md-4 d-flex justify-content-end">
    <button *ngIf="desativarInputsEBotoes===false" (click)="confirmar()" class="btn btn-success btn-lg px-5">
      Confirmar
    </button>
  </div>
</section>

<ng-template #contentModalCombo let-modal>
  <div class="modal-header d-flex justify-content-between align-items-center">
    <h2>Novo combo</h2>
    <button *ngIf="desativarInputsEBotoes===false" (click)="modal.close('close')" class="btn btn-xs btn-danger rounded-circle btn-icon">
      <i class="mdi mdi-close"></i>
    </button>
  </div>
  <div class="modal-body p-0">
    <div class="p-3">
      <label for="nomecombo">Nome</label>
      <input [readonly]="desativarInputsEBotoes===true" [formControl]="modalForm.nome" ngbAutofocus type="text" id="nomecombo" class="form-control">
      <app-msg-erro [control]="modalForm.nome"></app-msg-erro>
    </div>
    <div class="border-bottom border-grey-200 px-3 py-2 f-16">
      <h3>Consultas Veiculares</h3>
    </div>
    <div class="row my-2">
      <div *ngFor="let c of modalForm.consultas" class="col-12 col-lg-6 px-sm-3 px-2 py-2">
        <app-checkbox size='md' [label]="c.nome" [(checked)]="c.checked" [(disabled)]="c.disabled || desativarInputsEBotoes"></app-checkbox>
      </div>
    </div>

    <div class="border-bottom border-grey-200 px-3 py-2 f-16">
      <h3>Consultas de Crédito</h3>
    </div>
    <div class="row my-2">
      <div *ngFor="let c of modalForm.credito" class="col-12 col-lg-6 px-sm-3 px-2 py-2">
        <app-checkbox  size='md' [label]="c.nome" [(checked)]="c.checked" [(disabled)]="c.disabled || desativarInputsEBotoes"></app-checkbox>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button *ngIf="desativarInputsEBotoes===false" (click)="modal.close('ok')" [disabled]="modalForm.nome.invalid"
      class="btn btn-success btn-lg px-5">Confirmar</button>
  </div>
</ng-template>
